import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

// mutations declarations
export const SET_TASK_LOG = 'SET_TASK_LOG';
export const SET_SELECTED_TASK_ID = 'SET_SELECTED_TASK_ID';
export const SET_SELECTED_TASK_INFO = 'SET_SELECTED_TASK_INFO';
export const SET_NODE_RUN_DATA = 'SET_NODE_RUN_DATA';
export const SET_SELECTED_TASK_NODES = 'SET_SELECTED_TASK_NODES';
export const LOADING_LOGS = 'LOADING_LOGS';
export const LOADING_SELECTED_TASK_NODES = 'LOADING_SELECTED_TASK_NODES';
export const SET_ANALYTICS_RUNS_BY_DAY = 'SET_ANALYTICS_RUNS_BY_DAY';
export const SET_ANALYTICS_RUNS_BY_USER = 'SET_ANALYTICS_RUNS_BY_USER';
export const SET_ANALYTICS_RUNS_BY_FEATURE = 'SET_ANALYTICS_RUNS_BY_FEATURE';
export const SET_ANALYTICS_LATEST_ERRORS = 'SET_ANALYTICS_LATEST_ERRORS';
export const SET_PERSONAL_INTERFACES_TASK_LOG = 'SET_PERSONAL_INTERFACES_TASK_LOG';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_TASK_LOG](state, taskLog) {
		Vue.set(state, 'taskLog', taskLog);
	},
	[SET_PERSONAL_INTERFACES_TASK_LOG](state, { taskId, taskDetails }) {
		Vue.set(state.personalInterfacesTaskLog, taskId, taskDetails);
	},
	[SET_SELECTED_TASK_ID](state, taskId) {
		Vue.set(state, 'selectedTaskId', taskId);
	},
	[SET_SELECTED_TASK_INFO](state, taskInfo) {
		Vue.set(state, 'selectedTaskInfo', taskInfo);
	},
	[SET_NODE_RUN_DATA](state, payload) {
		const { nodeRunId, taskLog } = payload;
		Vue.set(state.nodeRunData, nodeRunId, taskLog);
	},
	[SET_SELECTED_TASK_NODES](state, nodes) {
		Vue.set(state, 'selectedTaskNodes', nodes);
	},
	[LOADING_LOGS](state, value) {
		state.loadingLogs = value;
	},
	[LOADING_SELECTED_TASK_NODES](state, value) {
		state.loadingSelectedTaskNodes = value;
	},
	[SET_ANALYTICS_RUNS_BY_DAY](state, runsByDay) {
		Vue.set(state, 'runsByDay', runsByDay);
	},
	[SET_ANALYTICS_RUNS_BY_USER](state, runsByUser) {
		Vue.set(state, 'runsByUser', runsByUser);
	},
	[SET_ANALYTICS_RUNS_BY_FEATURE](state, runsByFeature) {
		Vue.set(state, 'runsByFeature', runsByFeature);
	},
	[SET_ANALYTICS_LATEST_ERRORS](state, latestErrors) {
		Vue.set(state, 'latestErrors', latestErrors);
	},
};

export default mutations;
